import Pagination from './Pagination';
import { PaginationProps } from './types';

export type { PaginationProps };
export default Pagination;
